document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Product gallery carousel
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelector('[data-gallery-slides]');
    var slideItems = gallery.querySelectorAll('.product-gallery-slide');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var dots = gallery.querySelectorAll('.gallery-dot');
    var thumbs = gallery.querySelectorAll('.gallery-thumb');
    var variantSelect = document.querySelector('[data-variant-select]');

    if (!slides || slideItems.length <= 1) return;

    function scrollToSlide(index) {
      if (index < 0 || index >= slideItems.length) return;
      var targetSlide = slideItems[index];
      slides.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    function getCurrentIndex() {
      var scrollLeft = slides.scrollLeft;
      var slideWidth = slides.offsetWidth || 1;
      return Math.round(scrollLeft / slideWidth);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var currentIndex = getCurrentIndex();
        scrollToSlide(Math.max(0, currentIndex - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var currentIndex = getCurrentIndex();
        scrollToSlide(Math.min(slideItems.length - 1, currentIndex + 1));
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        scrollToSlide(idx);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
        scrollToSlide(idx);
      });
    });

    var scrollTimer;
    slides.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = getCurrentIndex();
        setActive(idx);
      }, 50);
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selectedOpt = variantSelect.options[variantSelect.selectedIndex];
        var imageId = selectedOpt ? selectedOpt.getAttribute('data-image-id') : null;
        if (imageId) {
          slideItems.forEach(function (item, idx) {
            if (item.getAttribute('data-media-id') === imageId) {
              scrollToSlide(idx);
            }
          });
        }
      });
    }
  });
});
